import { render, staticRenderFns } from "./taakOverview.vue?vue&type=template&id=735298fd&scoped=true"
import script from "./taakOverview.vue?vue&type=script&lang=js"
export * from "./taakOverview.vue?vue&type=script&lang=js"
import style0 from "./taakOverview.vue?vue&type=style&index=0&id=735298fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735298fd",
  null
  
)

export default component.exports